'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = _interopDefault(require('react'));
var propTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var Label = require('@narvar/nth-label');
var Label__default = _interopDefault(Label);

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();



















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

























var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject=taggedTemplateLiteral(['\n  position: ',';\n  width: ',';\n  min-width: ',';\n  height: ',';\n  border-style: ',';\n  border-color: ',';\n  border-width: ',';\n  border-radius: ',';\n  cursor: ',';\n  padding-left: ',';\n  padding-right: ',';\n  outline-width: ',';\n  background-color: ',';\n  font-size: ',';\n  color: ',';\n'],['\n  position: ',';\n  width: ',';\n  min-width: ',';\n  height: ',';\n  border-style: ',';\n  border-color: ',';\n  border-width: ',';\n  border-radius: ',';\n  cursor: ',';\n  padding-left: ',';\n  padding-right: ',';\n  outline-width: ',';\n  background-color: ',';\n  font-size: ',';\n  color: ',';\n']);
var _templateObject2=taggedTemplateLiteral(['\n  min-width: ',';\n  height: ',';\n  border-style: none;\n  cursor: ',';\n  padding-top: ',';\n  padding-right: ',';\n  padding-bottom: ',';\n  padding-left: ',';\n  outline-width: ',';\n  background-color: ',';\n  font-size: ',';\n  color: ',';\n  text-align: ',';\n  ','\n'],['\n  min-width: ',';\n  height: ',';\n  border-style: none;\n  cursor: ',';\n  padding-top: ',';\n  padding-right: ',';\n  padding-bottom: ',';\n  padding-left: ',';\n  outline-width: ',';\n  background-color: ',';\n  font-size: ',';\n  color: ',';\n  text-align: ',';\n  ','\n']);var disable=function(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{};return _extends({borderColor:'#e0e0e0',color:'#e0e0e0',cursor:'auto'},a)};var Container=styled.div(_templateObject,function(a){return a.s.position||'relative'},function(a){return a.s.width||'100%'},function(a){return a.s.minWidth||'6.25rem'},function(a){return a.s.height||'3.125rem'},function(a){return a.s.borderStyle||'solid'},function(a){return a.s.borderColor||'#999'},function(a){return a.s.borderWidth||'0.0625rem'},function(a){return a.s.borderRadius||'0.125rem'},function(a){return a.s.cursor||'text'},function(a){return a.s.paddingLeft||'0.75rem'},function(a){return a.s.paddingRight||'0.75rem'},function(a){return a.s.outlineWidth||'0'},function(a){return a.s.backgroundColor||'#fff'},function(a){return a.s.fontSize||'0.875rem'},function(a){return a.s.color||'#666'}); var StyledInput=styled.input(_templateObject2,function(a){return a.s.minWidth||'100%'},function(a){return a.s.height||'100%'},function(a){return a.s.cursor||'auto'},function(a){return a.s.paddingTop||'0'},function(a){return a.s.paddingRight||'0'},function(a){return a.s.paddingBottom||'0'},function(a){return a.s.paddingLeft||'0'},function(a){return a.s.outlineWidth||'0'},function(a){return a.s.backgroundColor||'transparent'},function(a){return a.s.fontSize||'0.875rem'},function(a){return a.s.color||'#000'},function(a){return a.s.textAlign||'left'},function(a){var b='';return a.defaultValue&&(b='\n        height: 56%;\n        margin-top: 1.25rem;\n      '),b}); var TextInput=function(a){var b=a.className,c=a.id,d=a.defaultValue,e=a.label,f=a.labelClassName,g=a.inputClassName,h=a.name,i=a.type,j=a.disabled,k=a.value,l=a.placeholder,m=a.onChange,n=a.onFocus,o=a.onBlur,p=a.minLength,q=a.maxLength,r=a.s,t=a.labelStyle,u=a.inputStyle;return jsx(Container,{className:b,s:j?disable(r):r},void 0,jsx(Label__default,{className:f,id:c,s:Label.transitionLabel({labelStyle:t,disabled:j,active:d})},void 0,e),jsx(StyledInput,{className:g,id:c,s:u,defaultValue:d,name:h,type:i,disabled:j,value:k,placeholder:l,onChange:m,onFocus:n,onBlur:o,minLength:p,maxLength:q}))};TextInput.defaultProps={className:'',defaultValue:void 0,labelClassName:'',inputClassName:'',name:'',type:'text',disabled:!1,value:void 0,placeholder:'',onChange:function onChange(){},onFocus:function onFocus(){},onBlur:function onBlur(){},maxLength:void 0,minLength:void 0,s:{},labelStyle:{},inputStyle:{}};

exports.disable = disable;
exports['default'] = TextInput;
//# sourceMappingURL=index.js.map
